import { $extraItem, $extras } from "./extras/extra";
import { $message, $messageLoad } from "./extras/message";

export const SExtraFilter = {
  install: Vue => {
    Vue.filter("extra", function(value, str) {
      if (value && str) {
        const arr = str.split(".");
        let v = null;
        let m = value;
        for (let i = 0; i < arr.length; i++) {
          v = m[arr[i]];
          if (v) {
            m = v;
          } else {
            m = "";
            break;
          }
        }
        return m;
      }
      return value;
    });
    Vue.mixin({
      computed: {
        extraItem: function() {
          return {
            extras: (str, defaultVal) => {
              return $extraItem(this.extras, str, defaultVal);
            }
          };
        }
      }
    });
  }
};

export { $extraItem, $extras, $message, $messageLoad };
